import React, { useContext, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { ConfirmContext } from "../contexts";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import { CustomToolbar, textLabels, Loading } from "../../../../components";
import { handleExporttoExcel } from "../../../components";
import _, { isArray } from "lodash";
import Container from "@material-ui/core/Container";
import { useMutation } from "@apollo/react-hooks";
import alertify from "alertifyjs";
import { confirmMutations, confirmQueries } from "../../../resolvers";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs({
  excelData,
  setExcelData,
  refetch,
  currentcompany,
  setUploadLoading,
}) {
  moment.locale();
  const { state, setState } = useContext(ConfirmContext);
  const { options: pageOptions } = state;
  const handleClose = () => {
    setState({ ...state, options: { ...state.options, dialog: false } });
    setExcelData([]);
  };
  const variableChecker = (data) => {
    const DataArray = data.map((x) => {
      const keys = Object.keys(x);
      let Data = { company: currentcompany.id };
      for (let i of keys) {
        if (x[i]) {
          if (i === "productDate")
            Data[i] =
              x[i].toString().length == 10
                ? moment(x[i].toString(), "DD.MM.YYYY")
                : moment(x[i].toString(), "D.MM.YYYY");
          else if (i === "controlNo") Data[i] = x[i].toString();
          else Data[i] = x[i];
        }
      }
      return Data;
    });
    return DataArray;
  };

  const handleSave = async () => {
    /*
    console.log({
      variables: {
        data: await variableChecker(excelData),
      },
    });
   */
    await save({
      variables: {
        data: await variableChecker(excelData),
      },
    });
    await refetch();
    handleClose();
    setUploadLoading(false);
  };

  const [save, { loading }] = useMutation(confirmMutations.MANUEL_CREATE, {
    onCompleted(data) {
      alertify.success(
        "Kaydınız Başarıyla Yapılmıştır. Güncel Kayıtlarınız Getiriliyor.",
        4
      );
    },
    onError(err) {
      console.log(err.message);
      let x = err.message.split(":", 3);
      alertify.error(x[2], 3);
    },
  });

  const handleDownload = async () => {
    const sheet = "Anzer Bal Aktarılacak Kayıtlar";
    const file = moment().format("DD.MM.YYYY").toString();
    const column = [
      { header: "Seri No", key: "serino", width: 20 },
      { header: "Kod", key: "code", width: 20 },
      { header: "Dolum Yapılan Kooperatif", key: "product", width: 20 },
      {
        header: "Dolum Yapılan Ambalaj Boyutu (gr)",
        key: "dimensions",
        width: 20,
      },
      { header: "Dolum Yeri", key: "productPalace", width: 20 },
      { header: "Dolum Tarihi", key: "productDate", width: 20 },
      { header: "Açıklama", key: "description", width: 20 },
    ];
    const rows = _.orderBy(excelData, ["productDate"], ["desc"]);
    const row = await rows.map((x) => {
      let type = "";
      if (isArray(x.type)) {
        x.type.forEach((e) => {
          type += e + ", ";
        });
      }
      return {
        serino: x.serino,
        code: x.code,
        product: x.product,
        dimensions: x.dimensions,
        productPalace: x.productPalace,
        productDate: x.productDate,
        description: x.description,
      };
    });
    handleExporttoExcel(file, sheet, column, row);
  };

  const columns = [
    {
      name: "serino",
      label: "No",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "code",
      label: "Kod",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "product",
      label: "Dolum Yapılan Kooperatif",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "dimensions",
      label: "Dolum Yapılan Ambalaj Boyutu (gr)",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "productPalace",
      label: "Dolum Yeri",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "productDate",
      label: "Dolum Tarihi",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "description",
      label: "Açıklama",
      options: {
        filter: false,
        sort: true,
      },
    },
  ];

  const options = {
    filter: true,
    print: false,
    download: false,
    viewColumns: true,
    responsive: "scrollMaxHeight",
    fixedHeader: true,
    customToolbar: () => <CustomToolbar handleDownload={handleDownload} />,
    selectableRows: "none",
    textLabels,
    rowsPerPage: 100,
    rowsPerPageOptions: [10, 15, 100, 500],
  };

  useEffect(() => {
    setUploadLoading(loading);
  }, [loading]);

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={pageOptions.dialog}
        fullWidth={true}
        maxWidth={"xl"}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Excel'den Kayıt Aktar
        </DialogTitle>
        <DialogContent dividers>
          <Container maxWidth="lg">
            <MUIDataTable
              title={"Üretim Bilgileri"}
              data={_.orderBy(excelData, ["productDate"], ["desc"])}
              columns={columns}
              options={options}
            />
          </Container>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleSave} color="primary">
            Listeyi Kaydet
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
